(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root = document) {
    root.querySelectorAll('[data-pm-section]').forEach(section => {
      if (section.dataset.pmReady) return;
      section.dataset.pmReady = 'true';
      section.querySelectorAll('[data-pm-gallery]').forEach(gallery => {
        const slides = [...gallery.querySelectorAll('[data-pm-slide]')];
        const thumbs = [...gallery.querySelectorAll('[data-pm-thumb]')];
        const status = gallery.querySelector('[data-pm-gallery-status]');
        let current = 0;
        const show = index => {
          current = (index + slides.length) % slides.length;
          slides.forEach((slide, i) => slide.hidden = i !== current);
          thumbs.forEach((button, i) => button.setAttribute('aria-pressed', String(i === current)));
          status.textContent = status.dataset.template.replace('[current]', current + 1).replace('[total]', slides.length);
        };
        gallery.querySelectorAll('button').forEach(button => button.hidden = false);
        gallery.querySelector('[data-pm-prev]').addEventListener('click', () => show(current - 1));
        gallery.querySelector('[data-pm-next]').addEventListener('click', () => show(current + 1));
        thumbs.forEach((button, i) => button.addEventListener('click', () => show(i)));
        gallery.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            show(current + (event.key === 'ArrowRight' ? 1 : -1));
            thumbs[current].focus();
          }
        });
        show(0);
      });
      const selector = section.querySelector('[data-pm-variant]');
      if (selector) selector.addEventListener('change', () => {
        const option = selector.selectedOptions[0];
        const button = section.querySelector('[data-pm-buy]');
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? button.dataset.sold : button.dataset.ready;
        section.querySelector('[data-pm-price]').textContent = option.dataset.price;
        const quantity = section.querySelector('[name="quantity"]');
        quantity.min = option.dataset.min;
        quantity.step = option.dataset.step;
        quantity.value = option.dataset.min;
        if (option.dataset.max) quantity.max = option.dataset.max;
        else quantity.removeAttribute('max');
      });
      if ('IntersectionObserver' in window && !reduced.matches) {
        const observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('pm-visible');
          observer.unobserve(entry.target);
        }), {threshold: .08});
        section.querySelectorAll('.pm-reveal').forEach(item => {
          item.classList.add('pm-awaiting');
          observer.observe(item);
        });
        reduced.addEventListener('change', event => {
          if (event.matches) section.querySelectorAll('.pm-reveal').forEach(item => item.classList.add('pm-visible'));
        }, {once: true});
      }
    });
    root.querySelectorAll('.pm-mobile-menu a').forEach(link => link.addEventListener('click', () => link.closest('details').open = false));
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
